/** @file quadEditOf: the quad change drawn this frame: the running handle drag, else a typed inspector value. */
import { shownTileOf } from './shownTileOf';
import type { QuadEdit, ViewportCtx } from './viewportCtx';

/**
 * `ctx.quad.edit` when a handle drag runs (or waits for its batch); else the store's `quadOverride` written by the
 * inspector (`by: 'typed'`) as a resize-style edit (the pivot pixel stays where the preview draws it, the tile moves
 * around it: what the game draws once the change lands) when the drawn puppet shows that entry for the part; else null.
 */
export function quadEditOf(ctx: ViewportCtx): QuadEdit | null {
  if (ctx.quad.edit !== null) return ctx.quad.edit;
  const o = ctx.store.getState().quadOverride;
  const drawableIndex = o?.by === 'typed' ? (ctx.puppet()?.bundle.puppet.drawables.findIndex((d) => d.id === o.drawable) ?? -1) : -1;
  if (o === null || drawableIndex < 0) return null;
  const ref = shownTileOf(ctx, drawableIndex);
  if (ref?.entry !== o.entry) return null;
  return {
    drawable: o.drawable, drawableIndex, ref, handle: 0, start: [0, 0], u: [0, 0], v: [0, 0], flip: [false, false],
    size0: o.size0, pivot0: o.pivot0, size: o.size, pivot: o.pivot, moved: true, pending: true,
  };
}
